import React, { useMemo } from 'react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Controller, useFormContext } from 'react-hook-form';

import { AddFilterActionBtn, DynamicActionCards, LineWithHover } from 'modules/automation/WorkflowBuilder/components';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import { actionOptions, defaultKeys, filterMap } from 'constants/automation';
import DelaySubCard from './DelaySubCard';
import './ActionBlock.css';

const ActionBlock = () => {
  const {
    actionMethods,
    watch,
    formState: { errors },
    setValue,
    getValues,
    clearErrors,
  } = useFormContext();
  const { fields, remove } = actionMethods || {};
  const filters = watch('filters');
  const trigger = watch('trigger');

  const actionOptionsFiltered = useMemo(() => {
    if (!trigger) return [];

    const allowedCodes = filterMap[trigger.code] || [];

    return actionOptions
      .map((group) => ({
        ...group,
        items: group.items.filter((item) => allowedCodes.includes(item.value)),
      }))
      .filter((group) => group.items.length > 0); // remove empty groups
  }, [trigger]);

  return (
    <>
      {fields?.map((item, index) => (
        <React.Fragment key={item.id}>
          <LineWithHover index={index} showAddFilter={filters?.length === 0 && index === 0 && trigger?.code !== 'TRIG_REVIEW_REQUEST'} />
          <div className="card-bg action-block p-3">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div className="d-flex align-items-start">
                <i className="fas fa-cogs text-primary mt-1 me-2"></i>
                <div className="d-flex">
                  <h6 className="sub-title text-gray-500 mb-0">Action {index + 1}</h6>
                </div>
              </div>
              <Button
                tooltip="Remove"
                tooltipOptions={{ showDelay: 500 }}
                icon="pi pi-trash danger-text"
                className="p-button-rounded p-button-text text-danger"
                onClick={() => remove(index)}
              />
            </div>
            <DelaySubCard index={index} />
            {trigger?.code === 'TRIG_REVIEW_REQUEST' && (
              <div className="d-flex align-items-center files-note mt-2 mb-2">
                <i className="pi pi-info-circle me-2" style={{ paddingTop: '2px' }}></i>
                The selected action will be performed only if the review request link has not been clicked.
                {/* <i className="pi pi-times cursor-pointer ms-3 me-1" onClick={() => setShowInfo(false)} style={{ paddingTop: '2px' }}></i> */}
              </div>
            )}

            <div className="action-selected ">
              <div className="col-12 col-lg-6">
                <span className="fw-bold fw-medium">
                  Action <span className="text-danger">*</span>
                </span>
                <Controller
                  name={`actions[${index}].action_code`}
                  control={actionMethods.control}
                  rules={{ required: 'Action is required' }}
                  render={({ field }) => (
                    <Dropdown
                      name={field.name}
                      value={field.value}
                      onChange={(e) => {
                        let delay = getValues(`actions[${index}].delay`);
                        setValue(`actions[${index}]`, { ...defaultKeys, delay });
                        clearErrors(`actions.${index}`);
                        field.onChange(e.value);
                      }}
                      inputRef={field.ref}
                      className="input-shadow w-100"
                      panelClassName="grouped-dropdown"
                      options={actionOptionsFiltered}
                      optionGroupLabel="label"
                      optionGroupChildren="items"
                      placeholder="Select Action"
                    />
                  )}
                />
                <RequiredValidation errors={errors} field={`actions.${index}.action_code`} />
              </div>
              <DynamicActionCards index={index} />
            </div>
          </div>
        </React.Fragment>
      ))}
      <AddFilterActionBtn showAddFilter={false} />
    </>
  );
};

export default ActionBlock;
